
$(function() {
	// checkCustomInputs();
	checkDateInputs();

    $('[data-background], img[data-src]').imageLoader();

    $('a.popup').click(function(e) {
        e.preventDefault();
        openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
    });


	// flags bij messages uitklappen:
    // $('a.actions-selected').click(function() {
    //
    // 	$('.message-flags').fadeOut(200);
    //
    // 	var showContainer = $(this).data('container');
    //
    // 	console.log(showContainer);
    //
    //     if ($('.'+showContainer+'').is(':visible')) {
    //         $('.'+showContainer).hide();
    //     } else {
    //         $('.'+showContainer).show();
    //     }
    //
    //     return false;
    // });
    //
	// // fade out van flags bij messages
	// $('.message-flags').hover(
	// 	function(){},
	// 	function(){
	// 		$(this).fadeOut(200);
	// 	}
	// );


    $(document).on('click', 'a.confirm', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin    = $('.confirm-popin');
        var textYes   = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
        var textNo    = $(this).data('text-no')  || $popin.find('.no').data('text-no');
        var onConfirm = $(this).data('onconfirm') || '';

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('confirm'));
        $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
        $popin.find('.no').text(textNo);
        $popin.modal();

        if (onConfirm) {
            $popin.find('.yes').attr('onclick', onConfirm);
        }
    });

    $(document).on('click', 'a.show-alert', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin = $('.alert-popin');

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('alert'));
        $popin.modal();
    });

    $(document).on('keyup', 'input[type=number]', function() {
        var min   = parseInt($(this).attr('min'));
        var max   = parseInt($(this).attr('max'));
        var value = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }
    });

	$(document).on('mousedown', '.toggle-pass', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') == 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType == 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', '.toggle-pass', function(e) {
		e.preventDefault();
	});

   	$('.modal').on('show.bs.modal', function(e) {
   		$('body').addClass('modal-active');
   	}).on('hide.bs.modal', function(e) {
   		$('body').removeClass('modal-active');
   	});

    $(window).resize(function() {
   		checkSidebarHeight();
   	}).resize();

});

var dateTimePickerIcons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-double-left',
    next: 'fa fa-chevron-double-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
};


$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
